import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";

// common
import common from "../features/admin/common/Slice";

// masters
import masters from "./masters";

// Dashboard
import dashboard from "./dashboard";

import usermanagement from "./usermanagement";

import legalrisk from "./legalrisk";

import couponmanagement from "./couponmanagement";

import banknsfc from "./banknsfc";

import exploreproperty from "./exploreproperty";

import bestproperty from "./bestproperty";

import propertyinspection from "./propertyinspection";

import ticketraised from "./ticketraised";

import kyc from "./kyc";

import shortlistedproperty from "./shortlistedproperty";

import wallet from "./wallet";

import inquiryform from "./inquiryform";

import activitytracker from "./activitytracker";

import pushnotification from "./pushnotification";

import reviewform from "./reviewform";

import contactform from "./contactform";

export const store = configureStore({
  reducer: {
    // settings
    settings: settings,
    //auth
    auth: auth,
    //common
    common: common,
    //masters
    masters,
    // dashboard
    dashboard,

    legalrisk,

    banknsfc,

    usermanagement,

    couponmanagement,

    exploreproperty,

    bestproperty,

    propertyinspection,

    ticketraised,

    kyc,

    shortlistedproperty,

    wallet,

    inquiryform,

    activitytracker,

    pushnotification,

    reviewform,

    contactform,
  },
});
